
import {
    UPDATE_TENANT_DETAILS_REQUEST,
    UPDATE_TENANT_DETAILS_SUCCESS,
    UPDATE_TENANT_DETAILS_FAILURE,
    RESET_TENANT_DETAILS_SUCCESS
  } from '../../../Constants/actionTypes';
  
  const initialState = {
    loading: false,
    tenantDetails: {},
    error: null,
    updateSuccess: false,
  };
  
  const tenantDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_TENANT_DETAILS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          updateSuccess: false,
        };
      case UPDATE_TENANT_DETAILS_SUCCESS:
        return {
          ...state,
          loading: false,
          updateSuccess: true,
          tenantDetails: action.payload,
        };
      case UPDATE_TENANT_DETAILS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          updateSuccess: false,
        };
        case RESET_TENANT_DETAILS_SUCCESS:
          return {
            ...state,
            error: null,
            updateSuccess: false,
          }
      default:
        return state;
    }
  };
  
  export default tenantDetailsReducer;
  